const AITRAVEL_SERVICE_ID = 1;
const FOREIGN_AIR_ORDER_ITEM_CATEGORY = 'foreign_air';

export const OVERSEAS_24H_SUPPORT_OPTION_KEY = 'overseas_24h_support';
export const OVERSEAS_24H_SUPPORT_PHONE_NUMBER = '050-3649-9938';

export const OVERSEAS_24H_SUPPORT_NOTICE_TITLE = '【海外航空券24時間365日サポートについて】';

export const OVERSEAS_24H_SUPPORT_NOTICE_BODY_LINES: string[] = [
  '貴社では「海外航空券24時間365日サポート」オプションをご利用いただいております。',
  '弊社営業時間外の海外航空券の変更・キャンセルのほか、出張先での急なトラブルへの相談対応も',
  '下記の専用サポート窓口にてご対応可能です。',
  '',
  '■専用サポート窓口（24時間365日対応）',
  `TEL：${OVERSEAS_24H_SUPPORT_PHONE_NUMBER}`,
  '※日本語・英語・中国語での対応が可能です。',
  '',
  '■ご連絡時にお伝えいただく情報',
  ' ・企業名',
  ' ・搭乗者名',
  ' ・航空券番号（e-ticket上に記載あり）',
  '※LCC・NDC（新規格）運賃の航空券は対象外です。',
  '※ご利用時は入電料金が発生いたします。'
];

export const shouldShowOverseas24hSupportNotice = (
  serviceId: number | null | undefined,
  availableOptions: string[] | null | undefined,
  orderItemCategory: string | null | undefined
): boolean => {
  return (
    serviceId === AITRAVEL_SERVICE_ID &&
    (availableOptions ?? []).includes(OVERSEAS_24H_SUPPORT_OPTION_KEY) &&
    orderItemCategory === FOREIGN_AIR_ORDER_ITEM_CATEGORY
  );
};
